import React from "react";
import "./Articles.css";
import { getImageSrc } from "../../utils/cmsAPI";

const ArticleCard = ({ article, onClick }) => {
  const imageSrc = article?.image ? getImageSrc(article.image) : null;
  
  return (
    <div
      className="article-card"
      onClick={onClick}
      role="button"
      aria-label={`View article: ${article?.title || "Untitled Article"}`}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={article?.image_alt || article?.title || "Article image"}
          className="article-image"
        />
      ) : (
        <div className="article-image-placeholder">
          {article?.title || "Untitled"}
        </div>
      )}
      <div className="article-content">
        <h3 className="article-title">{article?.title}</h3>
        {article?.short_description && (
          <p className="article-description">{article.short_description}</p>
        )}
      </div>
    </div>
  );
};

export default ArticleCard;